import { motion } from "framer-motion";
import { PhoneCall, Snowflake } from "lucide-react";
import { SNOW, CONTACT } from "../data";

export const SnowRemoval = () => {
  return (
    <section
      id="odsniezanie"
      data-testid="snow-section"
      className="bg-white py-14 md:py-20 border-b-2 border-[#09090B]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
        {/* Text */}
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="inline-block bg-[#DC2626] text-white font-anton uppercase tracking-widest text-xs px-3 py-1">
            Odśnieżanie
          </span>
          <h2 className="font-anton uppercase text-[#09090B] text-3xl md:text-4xl mt-4 leading-tight">
            Odśnieżanie terenów utwardzonych
          </h2>
          <p className="mt-4 text-zinc-600 text-base md:text-lg leading-relaxed max-w-xl">
            Usuwanie śniegu z parkingów, dróg wewnętrznych i terenów firmowych.
            Posypywanie solą i piachem oraz szybka reakcja na opady śniegu.
          </p>
          <a
            data-testid="snow-cta-call"
            href={CONTACT.phoneLink}
            className="mt-7 inline-flex bg-[#DC2626] text-white font-anton uppercase tracking-wider px-8 py-4 items-center justify-center gap-2 hover:bg-[#09090B] transition-colors"
          >
            <PhoneCall size={20} />
            Zadzwoń teraz
          </a>
        </motion.div>

        {/* Video card */}
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative border-2 border-[#09090B] overflow-hidden shadow-[10px_10px_0_0_rgba(220,38,38,1)]"
        >
          <video
            data-testid="snow-video"
            className="w-full h-56 sm:h-72 lg:h-80 object-cover block"
            src={SNOW.video}
            poster={SNOW.poster}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#09090B]/70 via-transparent to-transparent pointer-events-none" />
          <span className="absolute top-3 left-3 flex items-center gap-1.5 bg-[#DC2626] text-white font-anton uppercase text-xs tracking-widest px-3 py-1">
            <Snowflake size={14} /> Odśnieżanie
          </span>
          <span className="absolute bottom-3 left-3 right-3 text-white/90 text-xs">
            Przykład pracy sprzętu Bobcat przy odśnieżaniu
          </span>
        </motion.div>
      </div>
    </section>
  );
};
